import EventEmitter from 'src/helpers/EventEmitter'
import store from 'src/store'
import { DEG_TO_RAD } from 'src/helpers/MathUtils'

import TextureCache from 'src/helpers/TextureCache'
import FacesSpritesheet from '@/assets/sprites/faces' 
import ImageService from '@/services/ImageService'

import { TweenMax } from 'gsap'
const THREE = require('three')
import MovieClip from 'src/helpers/MovieClip'
import {findWhere} from '@/helpers/ArrayUtils'

import frag from '@/shaders/question/btn.frag'
import vert from '@/shaders/question/btn.vert'

  
class ResultFace extends THREE.Group { 

  constructor(config) {
 
    super();
 
    this.config = { 
      id: config.id ,
      complete: config.complete ,
      texture_id: config.texture_id 
    }

    this.tweenObj = {
      distortionAmt: config.distortionAmt,
      brightness: config.brightness,
      contrast: config.contrast,
      saturation: config.saturation,
      alpha: config.alpha,
      color: config.color,
      selectColorMix: 0.5
    }
  
    Object.assign(this, EventEmitter)  
   
    this.setup(); 
    this.resize() 
  }

  setComplete(value){
    this.config.complete = value
  }

  setup(){ 
 
    this.distortion_texture = this.createTexture(require('@/assets/img/question/result/distortion/mellow.jpg')); 
    this.tapHoldTexture = this.createTexture(this.config.texture_id);
    this.material = new THREE.ShaderMaterial({

      vertexShader : vert,
      fragmentShader : frag,
      transparent: true,
 
      uniforms : { 
        tDistortion: {
          value: this.distortion_texture,
          type: "t"
        },
        tDrawing: {
          value: this.tapHoldTexture,
          type: "t"
        }, 
        time :{
          type : "f",
          value : 0
        }, 
        alpha :{
          type : "f",
          value : this.tweenObj.alpha
        }, 
        distortionAmt :{
          type : "f",
          value : this.tweenObj.distortionAmt
        },
        brightness :{
          type : "f",
          value : this.tweenObj.brightness
        },
        contrast :{
          type : "f",
          value : this.tweenObj.contrast
        },
        saturation :{
          type : "f",
          value : this.tweenObj.saturation
        },
        selectColor :{
          type : "vec3",
          value : new THREE.Color(this.tweenObj.color)
        },
        selectColorMix :{
          type : "f",
          value : 0.5
        }
      }
    });

    this.geometry = new THREE.PlaneBufferGeometry(512 * 0.5,512* 0.5);
    this.mesh = new THREE.Mesh(
      this.geometry, 
      this.material
    );

    this.mesh.position.z = 10;  
    this.add(this.mesh)

  }

  setUniforms(tweenObj) {
    // this.material.uniforms.alpha.value = tweenObj.alpha;
    // this.material.uniforms.distortionAmt.value = tweenObj.distortionAmt;
    // this.material.uniforms.brightness.value = tweenObj.brightness;
    // this.material.uniforms.contrast.value = tweenObj.contrast;
    // this.material.uniforms.saturation.value = tweenObj.saturation;
    // this.material.uniforms.selectColor.value = new THREE.Color(tweenObj.color); 
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img); 
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.needsUpdate = true;
    return texture;
  }
 
  tick(tap_hold_ratio) { 
    this.material.uniforms.time.value -= 0.001; 
  }

  idle() {}

  tapholdProgress() { }
  
  tapholdRecord() {   }

  tapholdRelease() {}
    
  processing() {  }
    
  complete(val) { 

    switch(val) {
      case 0:
        this.furious();
        break;
      case 1:
        this.sad();
        break;
      case 2:
        this.angry();
        break;
      case 3:
        this.agitated();
        break;
      case 4:
        this.confused();
        break;
      case 5:
        this.mildlyamused();
        break;
      case 6:
        this.amused();
        break;
      case 7:
        this.happy();
        break;
      case 8:
        this.ecstatic();
        break;
      case 9:
        this.error();
        break;
    }
    
  }

  furious(){  }

  sad(){ }

  angry(){ }

  agitated(){  }

  confused(){ }

  mildlyamused(){  }
  
  amused(){   }

  happy(){   }

  ecstatic(){  }
  
  error(){  }
 

  // page route

  hide(){ 
    this.visible = false;
  }

  show(fromPos, toPos, toRot, delay){

    this.visible = true;
    let duration = 1 + Math.random();
    TweenMax.fromTo(this.position, duration, fromPos, {
      x: toPos.x,
      y: toPos.y,
      z: toPos.z,
      delay: delay,
      ease: 'Power2.easeOut' // window.Back.easeOut.config(2)
    }); 

    TweenMax.fromTo(this.rotation, duration, {
      z: 0 
    }, {
      delay: delay,
      z: toRot
    }); 

    TweenMax.fromTo(this.tweenObj, duration , { 
      brightness: 0.538,
      contrast: 0.221,
      saturation: 0.0,
      alpha: 0.0,
      selectColorMix: 0.5
    }, { 
      brightness: this.config.complete ? 0.0 : 0.3,
      contrast: this.config.complete ? 1.0 : 1.0,
      saturation: this.config.complete ? 1.0 : 0.0,
      alpha: this.config.complete ? 0.75 : 0.75,
      selectColorMix: this.config.complete ? 1.0 : 0.5,
      delay: delay,
      onUpdate: this.onUpdate,
      ease: 'Power2.easeIn'
    });
 
    TweenMax.fromTo(this.tweenObj, duration * 1.5 , {
      distortionAmt: 0.001 
    }, {
      distortionAmt: 0.8, 
      onUpdate: this.onUpdate,
      ease: 'Power2.easeOut'
    }); 
  }

  onUpdate = () => {
    this.material.uniforms.alpha.value = this.tweenObj.alpha;
    this.material.uniforms.distortionAmt.value = this.tweenObj.distortionAmt;
    this.material.uniforms.brightness.value = this.tweenObj.brightness;
    this.material.uniforms.contrast.value = this.tweenObj.contrast;
    this.material.uniforms.saturation.value = this.tweenObj.saturation;
    this.material.uniforms.selectColor.value = new THREE.Color(this.tweenObj.color); 
    this.material.uniforms.selectColorMix.value = this.tweenObj.selectColorMix;
  }


  question(val){

  }

  result(val){

  }

 
  resize() { }
 
 
}

export default ResultFace